import { apiCall } from "./api";
import { CONFIG } from "../config";
import { PrivateChatBootstrapResponse } from "./types";

export async function createPrivateChat(
  chatNumber: string,
  accessToken: string,
) {
  return apiCall<PrivateChatBootstrapResponse>(
    "PrivateChatCreateChatNumberFunction",
    {
      token: accessToken,
      body: { chatNumber },
      retries: 3,
      delayMs: 300,
      baseUrl: CONFIG.apiUrlSecondary,
    },
  );
}

export async function getPrivateChatInfo(
  userId: string,
  accessToken: string,
  additionalId?: string,
) {
  return apiCall<any>("PrivateChatInfoFunction", {
    token: accessToken,
    body: {
      userId,
      ...(additionalId ? { additionalId } : {}),
    },
    retries: 3,
    delayMs: 300,
    baseUrl: CONFIG.apiUrlSecondary,
  });
}

export async function chatDelete(
  userId: string,
  accessToken: string,
  chatId?: string,
) {
  return apiCall<any>("PrivateChatDeleteFunction", {
    token: accessToken,
    body: {
      userId,
      chatId,
    },
    retries: 3,
    delayMs: 300,
    baseUrl: CONFIG.apiUrlSecondary,
  });
}

export async function sendEncryptedMessage(accessToken: string, body: any) {
  return apiCall("MessageCreateFunction", {
    token: accessToken,
    body,
    baseUrl: CONFIG.apiUrlSecondary,
  });
}

export async function markChatSeen(
  accessToken: string,
  chatId: string,
  userId: string,
) {
  return apiCall("SeenMessageFunction", {
    token: accessToken,
    body: { chatId, userId },
    baseUrl: CONFIG.apiUrlSecondary,
  });
}

export async function createPrivateChatByPublicId(
  publicId: string,
  accessToken: string,
) {
  return apiCall<PrivateChatBootstrapResponse>(
    "PrivateChatCreatePublicItemFunction",
    {
      token: accessToken,
      body: { publicId },
      retries: 3,
      delayMs: 300,
      baseUrl: CONFIG.apiUrlSecondary,
    },
  );
}

export async function privateChatRealtimeEvent(
  accessToken: string,
  type:
    | "chat_active"
    | "chat_inactive"
    | "chat_heartbeat"
    | "typing_start"
    | "typing_stop",
  chatId: string,
) {
  // console.log("📡 Sending web realtime event:", type, chatId);

  return apiCall("private-chat/realtime/event", {
    token: accessToken,
    body: {
      type,
      chatId,
    },
    baseUrl: CONFIG.apiUrlSecondary,
  });
}